class BlockSize extends HTMLElement {
  connectedCallback() {
    this.optionName = this.getAttribute("data-select");

    this.variants = JSON.parse(
      document.getElementById("product-variants-json").textContent
    );

    this.markUnavailableOptions();
    this.initializeButtonListeners();
    this.listenToSelectChanges();
    this.syncFromCurrentSelect();
  }

  get selectSelector() {
    return `select[name="options[${this.optionName}]"]`;
  }

  markUnavailableOptions() {
    this.querySelectorAll(".block-size__btn").forEach((button) => {
      const value = button.value;

      const variant = this.variants.find(
        (v) => v.option1 == value || v.option2 == value || v.option3 == value
      );

      if (variant && !variant.available) {
        button.classList.add("sold-out");
        button.disabled = true;
      }
    });
  }

  initializeButtonListeners() {
    this.querySelectorAll(".block-size__btn").forEach((button) => {
      button.addEventListener("click", () => {
        if (button.classList.contains("sold-out")) return;

        this.updateSelect(button.value);
        this.setActiveButton(button.value);
      });
    });
  }

  listenToSelectChanges() {
    document.addEventListener("change", (event) => {
      if (!event.target.matches(this.selectSelector)) return;

      this.setActiveButton(event.target.value);
    });
  }

  updateSelect(value) {
    const select = document.querySelector(this.selectSelector);
    if (!select) return;

    select.value = value;
    select.dispatchEvent(new Event("change", { bubbles: true }));
  }

  setActiveButton(value) {
    this.querySelectorAll(".block-size__btn").forEach((btn) => {
      btn.classList.toggle(
        "active",
        btn.value === value && !btn.classList.contains("sold-out")
      );
    });
  }

  syncFromCurrentSelect() {
    const select = document.querySelector(this.selectSelector);
    if (select) {
      this.setActiveButton(select.value);
    }
  }
}

customElements.define("block-size", BlockSize);
